import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import RInput from "../../../../components/RInput";
import { UserDataProvider, UserProfileCom } from "../UserInLineEditView";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { getUserKaratDailyPromotionalOffersData, getUserPromotionalOffersData } from "../../../../API/UsersAPI/UsersApi";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Paper } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { HiOutlineArrowSmLeft, HiOutlineArrowSmRight } from "react-icons/hi";
import { saveAs } from "file-saver";



const recordCountSelecter = [10, 15, 20, 25, 30];
function UserDailyPromoHistory(props) {
    
  const navigator = useNavigate();
  const {userData} = useContext(UserDataProvider)
  const [userPromotionalOffersData,setUserPromotionalOffersData]=useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [recordCount, setRecordCount] = useState(recordCountSelecter[0]);
  const [period, setPeriod] = useState("7");
  const [startDate, setStartDate] = useState(dayjs().subtract(7, 'day'));
  const [endDate, setEndDate] = useState(dayjs(new Date()));
  // alert(startDate)
  const [loading, setLoading] = useState(true);
  // console.log(userData)
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    console.log(token);
    setLoading(true);
    console.log("params :", token,userData?._id,pageCount,
      recordCount, period,
      startDate.toString(),
      endDate.toString())

      getUserKaratDailyPromotionalOffersData(
      token,
      userData?._id,
      pageCount,
      recordCount,
      period,
      startDate.toString(),
      endDate.toString()
    )
      .then((res) => {
        if (typeof res.data === "object") {
          setUserPromotionalOffersData(
            res.data.map((item) => {
              return { ...item };
            })
          );
        }
        // alert(typeof res.data)
        console.log("data fetched", res);
        // alert("users data fetched");
        setLoading(false);
      })
      .catch((error) => {
        // alert("users data fetched" + error);
        console.log("error");
        setLoading(false);
        setUserPromotionalOffersData([])
      });
  }, [pageCount, recordCount, period,
    startDate,
    endDate]);
   
    const handleJsonPromoExport = () => {
      try {
        if(userPromotionalOffersData && Object.keys(userPromotionalOffersData).length > 0){
            // Convert the JSON object to a string representation
            const json = JSON.stringify(userPromotionalOffersData ?? {});
                
            // Create a Blob object for the JSON data
            const blob = new Blob([json], { type: "application/json;charset=utf-8;" });

            // Use file-saver to save the file
            saveAs(blob, `${userData?.username}-ParticipationHistory.json`);
        }
        else{
          alert("No Daily Karat promotional offers data available to export.")
        }        
      } catch (err) {
        console.error("Error converting JSON to file:", err);
      }
    };

  const getColumns = () => {
    const filteredEntries = Object.entries(
      Object.assign({}, ...userPromotionalOffersData)
    ).filter(
      ([key, value]) =>
        typeof value !== "function" &&
        typeof value !== "object" &&
        typeof value !== "symbol" &&
        typeof value !== "undefined"
    );
    const filteredObject = Object.fromEntries(filteredEntries);
    const dataKeys = Object.keys(filteredObject);
    return dataKeys.map((item, index) => {
      return index === 0
        ? {
            field: item,
            headerName: item,
            align: "center",
            headerAlign: "center",
            sortable: false,
            editable: false,
            // renderCell: (params) => {
            //   return <CustomCellComponent value={params.value} />;
            // },
            width: 150,
          }
        : {
            field: item,
            headerName: item,
            align: "center",
            headerAlign: "center",
            sortable: false,
            editable: true,
          };
    });
  };

  const columns: GridColDef[] = [...getColumns()];

  const rows = userPromotionalOffersData.map((item, index) => {
    const filteredEntries = Object.entries(item ?? {}).filter(
      ([key, value]) =>
        typeof value !== "function" &&
        typeof value !== "object" &&
        typeof value !== "symbol" &&
        typeof value !== "undefined"
    );
    const filteredObject = Object.fromEntries(filteredEntries);
    return { ...filteredObject, id: index };
  });
  return (
    <>
      <Row >
        <Col xs={2}>
          <UserProfileCom />
        </Col>
        <Col xs={10}>
          <div>
            <div>
              <h1 className="sideHeadingSty">Daily Karat Promotional Info</h1>
              <div>
                <Row className="input-row">
                  <Col xs={6}>
                    <RInput lable={"Current Number Of Promo Coins"} value={userData?.promoTokens} keyName={"promoTokens"} />
                  </Col>
                  <Col xs={6}>
                    <RInput lable={"Promo Token Progress"} value={userData?.promoTokenProgress} keyName={"promoTokenProgress"}/>
                  </Col>
                </Row>
              </div>
            </div>
            <div>
              {/* <Row className="input-row">
                <Col xs={6}>
                  <RInput lable={"Placeholder"} />
                </Col>
                <Col xs={6}>
                  <RInput lable={"Current Login"} />
                </Col>
              </Row> */}
            </div>
          </div>
        </Col>
      </Row>

      <div>
        <div>
        <Row className="input-row">
            <Col xs={10}>
              <h1 className="sideHeadingSty" style={{ marginLeft: "1%" }}>
                Participation History
              </h1>
            </Col>
            <Col xs={2} >
              <Button id="button-addon2" style={{backgroundColor:"#0079FF",color:"white",border:"none",marginLeft:10}} onClick={()=>{handleJsonPromoExport()}}>
                Export Json
              </Button>  
            </Col>
         </Row>
         
          
        </div>
        <div>
          <Row
            style={{
              display: "flex",
              alignItems: "flex-end",
              marginBottom: "1.5%",
            }}
          >
            <Col>
              {["7", "30", "60", "Lifetime"].map((value) => {
                return (
                  <Button
                    style={{ borderRadius: 15, margin: "0 10px" }}
                    variant="outline-secondary"
                    active={period === value}
                    onClick={() => {
                      setPageCount(1);setPeriod(value);
                      if(value==="Lifetime"){
                        setStartDate(dayjs("2024-04-01"));
                      }
                      else{
                        setStartDate(dayjs().subtract(value, "days"));
                      }
                      setEndDate(dayjs(new Date()))
                    }}
                    disabled={loading}
                  >
                    {value === "Lifetime" ? value : `Last ${value} Days`}
                  </Button>
                );
              })}
            </Col>

            <Col style={{ display: "flex", justifyContent: "flex-end" }}>
              <div>
                
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Start Date"
                    value={startDate}
                    onChange={(newValue) => {setPeriod("");setPageCount(1);setStartDate(newValue);}}
                    minDate={dayjs("2024-04-01")}
                    maxDate={dayjs(new Date())}
                    disabled={loading}
                  />
                </LocalizationProvider>
              </div>
              <div style={{marginLeft:"1%"}}>
              <LocalizationProvider dateAdapter={AdapterDayjs} >
                  <DatePicker
                    label="End Date"
                    value={endDate}
                    onChange={(newValue) => {setPeriod("");setPageCount(1);setEndDate(newValue);}}
                    minDate={dayjs("2024-04-01")}
                    maxDate={dayjs(new Date())}
                    disabled={loading}
                  />
                </LocalizationProvider>
              </div>
            </Col>
          </Row>
        </div>
        <Paper sx={{ height: "65vh", width: "100%" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                // paginationModel: { pageSize: recordCount },
                meta: { hasNextPage: true },
              },
            }}
            pageSizeOptions={[5, 10, 15]}
            paginationMode="client"
            pagination
            // estimatedRowCount={500}
            // hideFooterSelectedRowCount={true}
            rowSpacingType="border"
            // autoPageSize
            hideFooterPagination
            hideFooter
            rowCount={1000}
            onPaginationMetaChange={() => {
              alert("changed");
            }}
            // checkboxSelection
            sx={{ border: 0 }}
            loading={loading}
            onProcessRowUpdateError={(error) => {
              alert("on Process Row Update Error");
            }}
            disableRowSelectionOnClick
            onPaginationModelChange={(model) => {
              // setPaginationModel(model);
              // console.log(model);
              // getMoreData();
            }}
            onRowDoubleClick={(item) => {
              alert(item?.row?._id);
            }}
            // autosizeOptions={{
            //     columns: ['dob', 'status', 'createdBy'],
            //     includeOutliers: false,
            //     includeHeaders: false,
            //   }}
          />
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginTop: "1%",
              paddingRight: "2%",
            }}
          >
            <div
              style={{
                width: "auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  // border: "1px solid black",
                  width: "auto",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p style={{ margin: "0", color: "black", margin: "0 0.5vw" }}>
                  Row per page
                </p>
              </div>

              <div
                style={{
                  // border: "1px solid black",
                  width: "auto",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Form.Select
                  size="sm"
                  onChange={(event) => {
                    setRecordCount(event.target.value);
                  }}
                  disabled={loading}
                >
                  {recordCountSelecter.map((value, index) => {
                    return <option key={index + "values"}>{value}</option>;
                  })}
                </Form.Select>

                <p
                  style={{ margin: "0", color: "black", margin: "0 0.5vw" }}
                ></p>
              </div>
              <Button
                onClick={() => {
                  setPageCount((page) => page - 1);
                }}
                disabled={pageCount <= 1 || loading}
              >
                <HiOutlineArrowSmLeft />
              </Button>

              <div
                style={{
                  // border: "1px solid black",
                  width: "auto",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <p style={{ margin: "0", color: "black", margin: "0 0.5vw" }}>
                  {pageCount}
                </p>
              </div>

              <Button
                onClick={() => {
                  // getMoreData();
                  setPageCount((page) => page + 1);
                }}
                disabled={loading}
              >
                <HiOutlineArrowSmRight />
              </Button>
            </div>
          </div>
        </Paper>
      </div>
    </>
  );
}

export default UserDailyPromoHistory;
